"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var blockade_png_1 = __importDefault(require("./catchTypes/blockade.png"));
var drag_png_1 = __importDefault(require("./catchTypes/drag.png"));
var fyke_png_1 = __importDefault(require("./catchTypes/fyke.png"));
var hook_png_1 = __importDefault(require("./catchTypes/hook.png"));
var net_png_1 = __importDefault(require("./catchTypes/net.png"));
var seine_png_1 = __importDefault(require("./catchTypes/seine.png"));
var trap_png_1 = __importDefault(require("./catchTypes/trap.png"));
var trawl_png_1 = __importDefault(require("./catchTypes/trawl.png"));
var board_jpg_1 = __importDefault(require("./board.jpg"));
exports.default = {
    catchTypes: {
        hook: hook_png_1.default,
        drag: drag_png_1.default,
        trap: trap_png_1.default,
        seine: seine_png_1.default,
        blockade: blockade_png_1.default,
        trawl: trawl_png_1.default,
        net: net_png_1.default,
        fyke: fyke_png_1.default
    },
    blackBoard: board_jpg_1.default
};
//# sourceMappingURL=index.js.map